import { axiosApiInstance, USER_ENDPOINT } from "endpoint/index";

const buyPackage = async (NFTId, pkgId) => {
  await axiosApiInstance.post(`${USER_ENDPOINT}/buy-package/${pkgId}/${NFTId}`);
  return NFTId;
};

export default buyPackage;
